import { render } from "./CodeInput.vue?vue&type=template&id=466dc636"
import script from "./CodeInput.vue?vue&type=script&lang=ts"
export * from "./CodeInput.vue?vue&type=script&lang=ts"
script.render = render

export default script